import { IDepartment } from '../../shared/types/filters';

export const convertToNestedFormat = (teamsData: IDepartment[]) => {
  const teamMap = new Map();
  const topLevelTeams: any[] = [];

  teamsData.forEach((team) => {
    const teamCopy = { ...team, children: [] };
    teamMap.set(team.id, teamCopy);

    if (team.parentTeamId === null) {
      topLevelTeams.push(teamCopy);
    }
  });

  teamMap.forEach((team, id) => {
    const parentTeam = teamMap.get(team.parentTeamId);
    if (parentTeam) {
      parentTeam.children.push(team);
    } else if (team.parentTeamId !== null) {
      topLevelTeams.push(team);
    }
  });

  return topLevelTeams;
};
